export default __webpack_public_path__ + "static/media/1867.077a1ec5.png";